<template>
  <el-card class="h-full" :body-style="{ height: '100%', overflow: 'auto' }">
    <div class="flex items-center">
      <span class="border-l-3 border-color-primary flex-1 pl-10px text-18px">左侧列表设置</span>
    </div>
    <div class="mt-20px">
      <el-form
        :model="leftRuleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="150px"
        class="demo-ruleForm"
      >
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="展示组件" prop="showComponent">
              <el-select
                :disabled="true"
                v-model="leftRuleForm.showComponent"
                placeholder="请选择展示组件"
              >
                <el-option
                  v-for="(option, index) in modelList"
                  :key="index"
                  :label="option.name"
                  :value="option.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="数据来源" prop="source">
              <el-select
                ref="leftDataSourceSelect"
                :disabled="canEdit"
                v-model="leftRuleForm.source"
                placeholder="请选择数据来源"
                popper-class="data-source-select-tree"
                size="small"
                @visible-change="visibleSelectChange"
              >
                <el-option
                  :label="columnName"
                  :value="leftRuleForm.source"
                  :style="{ padding: 0, height: '100%', fontWeight: 'normal' }"
                >
                  <el-tree
                    :props="{
                      label: 'name',
                      children: 'child',
                    }"
                    class="text-white max-h-274px overflow-x-hidden data-source-tree"
                    ref="leftTreeRef"
                    node-key="id"
                    highlight-current
                    :data="columnData"
                    @node-click="treeNodeClick"
                    :expand-on-click-node="false"
                    :default-expanded-keys="defaultExpandedKeys"
                  ></el-tree>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="列表样式" prop="listStyle">
              <el-select
                :disabled="canEdit"
                v-model="leftRuleForm.listStyle"
                placeholder="请选择列表样式"
              >
                <el-option
                  v-for="(option, index) in listType"
                  :key="index"
                  :label="option.name"
                  :value="option.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="展示行数" prop="row">
              <el-input-number
                :disabled="canEdit"
                v-model="leftRuleForm.row"
                :min="1"
                :max="100"
                controls-position="right"
                class="max-w-1/1 !w-202px"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="每行展示条数" prop="col">
              <el-input-number
                :disabled="canEdit"
                v-model="leftRuleForm.col"
                :min="1"
                :max="100"
                controls-position="right"
                class="max-w-1/1 !w-202px"
              /> </el-form-item
          ></el-col>
          <el-col :span="8">
            <el-form-item label="展示内容" prop="displayContent">
              <el-checkbox-group v-model="leftRuleForm.displayContent" :disabled="canEdit">
                <el-checkbox
                  label="显示摘要"
                  name="type"
                  v-if="
                    leftRuleForm.listStyle !== 'NewsThree' && leftRuleForm.listStyle !== 'NewsFour'
                  "
                ></el-checkbox>
                <el-checkbox
                  label="显示时间"
                  name="type"
                  v-if="leftRuleForm.listStyle !== 'NewsThree'"
                ></el-checkbox>
                <el-checkbox
                  label="显示分页"
                  name="type"
                  v-if="leftRuleForm.listStyle !== 'NewsThree'"
                ></el-checkbox>
                <el-checkbox
                  label="显示栏目名称"
                  name="type"
                  v-if="leftRuleForm.listStyle !== 'NewsThree'"
                ></el-checkbox>
                <el-checkbox label="显示更多"></el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="flex items-center">
      <span class="border-l-3 border-color-primary flex-1 pl-10px text-18px">右侧列表设置</span>
    </div>
    <div class="mt-20px">
      <el-form
        :model="rightRuleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="150px"
        class="demo-ruleForm"
      >
        <el-row :gutter="24">
          <el-col :span="8">
            <el-form-item label="展示组件" prop="showComponent">
              <el-select
                :disabled="true"
                v-model="rightRuleForm.showComponent"
                placeholder="请选择展示组件"
              >
                <el-option
                  v-for="(option, index) in modelList"
                  :key="index"
                  :label="option.name"
                  :value="option.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="数据来源" prop="source">
              <el-select
                ref="rightDataSourceSelect"
                :disabled="canEdit"
                v-model="rightRuleForm.source"
                placeholder="请选择数据来源"
                popper-class="data-source-select-tree"
                size="small"
                @visible-change="rightVisibleSelectChange"
              >
                <el-option
                  :label="rightColumnName"
                  :value="rightRuleForm.source"
                  :style="{ padding: 0, height: '100%', fontWeight: 'normal' }"
                >
                  <el-tree
                    :props="{
                      label: 'name',
                      children: 'child',
                    }"
                    class="text-white max-h-274px overflow-x-hidden data-source-tree"
                    ref="rightTreeRef"
                    node-key="id"
                    highlight-current
                    :data="columnData"
                    @node-click="rightTreeNodeClick"
                    :expand-on-click-node="false"
                    :default-expanded-keys="rightDefaultExpandedKeys"
                  ></el-tree>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="列表样式" prop="listStyle">
              <el-select
                :disabled="canEdit"
                v-model="rightRuleForm.listStyle"
                placeholder="请选择列表样式"
              >
                <el-option
                  v-for="(option, index) in listType"
                  :key="index"
                  :label="option.name"
                  :value="option.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="展示行数" prop="row">
              <el-input-number
                :disabled="canEdit"
                v-model="rightRuleForm.row"
                :min="1"
                :max="100"
                controls-position="right"
                class="max-w-1/1 !w-202px"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="每行展示条数" prop="col">
              <el-input-number
                :disabled="canEdit"
                v-model="rightRuleForm.col"
                :min="1"
                :max="100"
                controls-position="right"
                class="max-w-1/1 !w-202px"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="展示内容" prop="displayContent">
              <el-checkbox-group v-model="rightRuleForm.displayContent" :disabled="canEdit">
                <el-checkbox
                  label="显示摘要"
                  name="type"
                  v-if="rightRuleForm.listStyle !== 'NewsThree'"
                ></el-checkbox>
                <el-checkbox
                  label="显示时间"
                  name="type"
                  v-if="rightRuleForm.listStyle !== 'NewsThree'"
                ></el-checkbox>
                <el-checkbox
                  label="显示分页"
                  name="type"
                  v-if="rightRuleForm.listStyle !== 'NewsThree'"
                ></el-checkbox>
                <el-checkbox
                  label="显示栏目名称"
                  name="type"
                  v-if="rightRuleForm.listStyle !== 'NewsThree'"
                ></el-checkbox>
                <el-checkbox label="显示更多"></el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="w-full fixed bottom-20px left-1/2">
      <el-button
        v-if="canEdit === true"
        size="small"
        type="primary"
        @click="canEdit = false"
      >
        编辑
      </el-button>
      <el-button v-if="canEdit === false" size="small" type="primary" @click="submit">
        保存
      </el-button>
      <el-button v-if="canEdit === false" size="small" @click="cancel">
        取消
      </el-button>
    </div>
  </el-card>
</template>

<script>
import { WorkbenchSettingApi, ColumApi } from '@wiz-api/workbench'
import { treeToOneArray } from '@/assets/js/Common'
import { listType } from '../../js/config'

const workbenchSettingApi = new WorkbenchSettingApi()
const columApi = new ColumApi()
export default {
  data() {
    return {
      canEdit: true,
      leftRuleForm: {
        id: null,
        showComponent: '列表',
        source: '',
        listStyle: '',
        displayContent: ['显示摘要', '显示时间', '显示分页', '显示栏目名称', '显示更多'],
        row: 5,
        col: 1,
        type: 0,
      },
      rightRuleForm: {
        id: null,
        showComponent: '列表',
        source: '',
        listStyle: '',
        displayContent: ['显示摘要', '显示时间', '显示分页', '显示栏目名称', '显示更多'],
        row: 5,
        col: 1,
        type: 1,
      },
      patternList: [],
      modelList: [],
      sourceList: [],
      rules: {},
      listType,
      columnFlattenData: [],
      defaultExpandedKeys: [],
      columnName: '',
      columnData: [],
      rightColumnName: '',
      rightDefaultExpandedKeys: [],
    }
  },
  mounted() {
    this.getModules()
    this.getColumnData()
    this.getWorkbenchSetting()
  },
  methods: {
    async getColumnData() {
      const [err, res] = await columApi.tree(0)
      if (!err) {
        this.columnData = res
        this.columnFlattenData = treeToOneArray(res, 'child')
        if (this.leftRuleForm.source) {
          this.columnName = _.find(this.columnFlattenData, {
            id: this.leftRuleForm.source,
          })?.name
        }
        if (this.rightRuleForm.source) {
          this.rightColumnName = _.find(this.columnFlattenData, {
            id: this.rightRuleForm.source,
          })?.name
        }
      }
    },
    visibleSelectChange(boolean) {
      this.$nextTick(() => {
        if (boolean) {
          this.$refs.leftTreeRef.setCurrentKey(this.leftRuleForm.source) // 设置选中元素
          this.defaultExpandedKeys = [this.leftRuleForm.source]
        } else {
          const nodeDatas = this.$refs.leftTreeRef.store.nodesMap
          _.forIn(nodeDatas, (val) => {
            val.expanded = false
          })
        }
      })
    },
    treeNodeClick(node) {
      this.leftRuleForm.source = node.id
      this.columnName = node.name
      this.$refs.leftDataSourceSelect.blur()
    },
    rightVisibleSelectChange(boolean) {
      this.$nextTick(() => {
        if (boolean) {
          this.$refs.rightTreeRef.setCurrentKey(this.rightRuleForm.source) // 设置选中元素
          this.defaultExpandedKeys = [this.rightRuleForm.source]
        } else {
          const nodeDatas = this.$refs.rightTreeRef.store.nodesMap
          _.forIn(nodeDatas, (val) => {
            val.expanded = false
          })
        }
      })
    },
    rightTreeNodeClick(node) {
      this.rightRuleForm.source = node.id
      this.rightColumnName = node.name
      this.$refs.rightDataSourceSelect.blur()
    },
    async getModules() {
      const [err, res] = await columApi.tree(1)
      if (!err && res) {
        this.modelList = res
      }
    },
    async getSource() {
      const [err, res] = await columApi.tree(0)
      if (!err && res) {
        this.sourceList = res
      }
    },
    async getWorkbenchSetting() {
      const [err, res] = await workbenchSettingApi.getWorkbenchSetting({ code: 'leftWorkbench' })
      const [errRight, resRight] = await workbenchSettingApi.getWorkbenchSetting({
        code: 'rightWorkbench',
      })
      if (!err && res) {
        if (res.config && JSON.parse(res.config).source) {
          this.columnName = _.find(this.columnFlattenData, {
            id: JSON.parse(res.config).source,
          })?.name
        }
        this.leftRuleForm = { ...this.leftRuleForm, ...JSON.parse(res.config) }
        delete this.leftRuleForm.config
        this.leftRuleForm.id = res.id
      }
      if (!errRight && resRight) {
        if (resRight.config && JSON.parse(resRight.config).source) {
          this.rightColumnName = _.find(this.columnFlattenData, {
            id: JSON.parse(resRight.config).source,
          })?.name
        }
        this.rightRuleForm = { ...this.rightRuleForm, ...JSON.parse(resRight.config) }
        delete this.rightRuleForm.config
        this.rightRuleForm.id = resRight.id
      }
    },
    async submit() {
      const [err, res] = await workbenchSettingApi.updateWorkbenchSetting({
        body: {
          id: this.leftRuleForm.id ? this.leftRuleForm.id : null,
          config: JSON.stringify(this.leftRuleForm),
          code: 'leftWorkbench',
        },
      })
      const [errRight, resRight] = await workbenchSettingApi.updateWorkbenchSetting({
        body: {
          id: this.leftRuleForm.id ? this.rightRuleForm.id : null,
          config: JSON.stringify(this.rightRuleForm),
          code: 'rightWorkbench',
        },
      })
      if (!err && !errRight && res && resRight) {
        this.$message.success('修改成功')
        this.canEdit = true
      }
    },
    cancel() {
      this.getWorkbenchSetting()
      this.canEdit = true
    },
  },
}
</script>

<style lang="scss" scoped>
.data-source-tree {
  &::-webkit-scrollbar {
    width: 6px;
  }
  ::v-deep .el-tree-node__content {
    height: 36px;
  }
}
</style>
<style lang="scss">
.data-source-select-tree {
  .el-select-dropdown__wrap {
    max-height: 100%;
  }
}
</style>
